import { render, staticRenderFns } from "./PointTabContent.vue?vue&type=template&id=460fe828&"
import script from "./PointTabContent.vue?vue&type=script&lang=ts&"
export * from "./PointTabContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports